import { LocalStorageKey, useLocalStorage } from '~/components/hooks/useLocalStorage'

export function useAdminContext() {
  const [adminDataRaw] = useLocalStorage(LocalStorageKey.ADMIN_DATA)
  const adminData = JSON.parse(adminDataRaw ?? '{}')
  const adminUser = adminData?.adminUser
  const impersonatedUser = adminData?.impersonatedUser
  return { adminUser, impersonatedUser, isImpersonating: impersonatedUser?.name !== undefined }
}
